import {
  formatApprovalDateTime,
  formatNamedCode,
  productivityStatusChipClass,
} from '../utils/productivityApprovalPresentation'

function DetailItem({ label, value, className = '' }) {
  return (
    <div className={`rounded-2xl bg-surface-container-low px-5 py-4 ${className}`}>
      <dt className="text-[11px] font-bold uppercase tracking-[0.16em] text-on-surface-variant">{label}</dt>
      <dd className="mt-2 text-sm font-semibold text-on-surface">{value || 'N/A'}</dd>
    </div>
  )
}

export default function ProductivityAdjustmentDetails({ item }) {
  if (!item) return null
  const status = String(item.approvalStatus || 'PENDING').toUpperCase()

  return (
    <div className="space-y-6">
      <section className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
        <DetailItem label="Employee" value={item.userName} />
        <DetailItem label="Department" value={item.departmentName} />
        <DetailItem label="Reporting Manager" value={item.reportingManagerName} />
        <DetailItem label="Submitted At" value={formatApprovalDateTime(item.createdAt)} />
        <DetailItem label="Project" value={formatNamedCode(item.projectName, item.projectCode)} />
        <DetailItem label="Task" value={formatNamedCode(item.taskName, item.taskCode)} />
        <DetailItem label="Requested Hours" value={item.manualActiveLabel || '0m'} />
        <DetailItem
          label="Approval Status"
          value={(
            <span className={`inline-flex rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider ${productivityStatusChipClass(status)}`}>
              {status}
            </span>
          )}
        />
      </section>

      <section className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <DetailItem label="Productivity Reason" value={item.reasonLabel} />
        <DetailItem label="Employee Remark" value={item.remark || 'N/A'} />
        <DetailItem label="Session Login" value={formatApprovalDateTime(item.sessionLoginAt)} />
        <DetailItem label="Session Logout" value={formatApprovalDateTime(item.sessionLogoutAt)} />
        <DetailItem label="Reviewed By" value={item.approvedByName || item.rejectedByName || 'N/A'} />
        <DetailItem label="Reviewed At" value={formatApprovalDateTime(item.approvedAt || item.rejectedAt)} />
        <DetailItem label="Decision Remark" value={item.decisionRemark || 'N/A'} className="lg:col-span-2" />
      </section>
    </div>
  )
}
